import { Link } from "react-router-dom";
import styled from "@emotion/styled";

const StyledLink = styled(Link)`
  color: #379ae6ff;
`;

export default StyledLink;
